import {
  Button,
  Typography,
  FormHelperText,
  FormLabel,
  TextField,
  Box,
} from "@mui/material";
import { styled } from "@mui/material";
import { Poppins } from "next/font/google";

const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

export const CTypography = styled(Typography)(({ theme }) => ({
  color: "#0B132B",
  fontSize: "1rem",
  fontWeight: 400,
  fontFamily: poppins.style.fontFamily,
}));

export const ContainedButton = styled(Button)(({ theme }) => ({
  padding: "16px 0px !important",
  color: "#fff !important",
  fontFamily: poppins.style.fontFamily,
  fontSize: "1rem !important",
  fontWeight: 500,
  lineHeight: "24px",
  background: "#004FE0 !important",
  boxShadow: "none !important",
  borderRadius: "10px !important",
  "&:hover": {
    boxShadow: "none !important",
    background: "#004FE0 !important",
  },
}));

export const SignInWithButton = styled(Button)(({ theme }) => ({
  padding: "13px",
  color: "#0B132B",
  fontFamily: poppins.style.fontFamily,
  fontSize: "14px",
  lineHeight: "16px",
  borderColor: "#E4E8EC",
  borderRadius: "10px",
  "& .text": {
    flex: 1,
  },
  "& svg": {
    color: "#004FE0",
  },
}));

export const CTextButton = styled(Button)(({ theme }) => ({
  p: 0,
  m: 0,
  height: "1rem",
  // width: "fit-content",
  fontFamily: poppins.style.fontFamily,
  textAlign: "center",
  fontWeight: 400,
  color: "#004FE0 !important",
  // justifyContent: "flex-start",
}));

export const CustomFormLabel = styled(FormLabel)(({ theme }) => ({
  marginBottom: "8px",
  color: "#0B132B",
  display: "block",
  fontSize: "1rem",
  fontWeight: 500,
  fontFamily: poppins.style.fontFamily,
  lineHeight: "26px",
  "& .asterisk": {
    color: "#BA1A1A",
  },
}));

export const CTextField = styled(TextField)(({ theme }) => ({
  // background: "#F8F9FB",
  "& .MuiOutlinedInput-input": {
    padding: "17.8px 14px",
  },
  "& .MuiOutlinedInput-input::placeholder": {
    // color: "rgba(187, 191, 201, 1)",
    // color: "rgba(187, 191, 210, 1)",
    color: "#686868",
    // color: "#BBBFC9",
  },
  borderRadius: "8px",
  fontFamily: poppins.style.fontFamily,
  fontSize: "20px",
  "& .MuiOutlinedInput-root": {
    fontFamily: poppins.style.fontFamily,
    fontSize: "20px",
    // background: "#F8F9FB",
    borderRadius: "8px",
  },
  "& .MuiFormHelperText-root.Mui-error": {
    marginLeft: "0px",
    color: "#BA1A1A !important",
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: poppins.style.fontFamily,
  },
  "& .MuiFormHelperText-root": {
    marginTop: "8px",
    marginLeft: "0px",
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: poppins.style.fontFamily,
  },
  // "& .MuiOutlinedInput-notchedOutline": {
  //   borderColor: "#BA1A1A !important",
  // },
}));

export const CFormContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  fontFamily: poppins.style.fontFamily,
  "& .MuiTextField-root, & .MuiSelect-root": {
    m: 0,
    "& fieldset": {
      borderRadius: 0,
    },
  },
  "& > :first-child fieldset": {
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
  },
  "& > :nth-child(2) fieldset": {
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
  },
  "& > :not(:last-child) fieldset": {
    //   borderBottom: "none",
  },
}));

export const CustomFormContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  fontFamily: poppins.style.fontFamily,
  "& .MuiTextField-root, & .MuiSelect-root": {
    m: 0,
    "& fieldset": {
      borderRadius: 0,
    },
  },
  "& > :first-child fieldset": {
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
  },
  "& > :last-child fieldset": {
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
  },
  "& > :not(:last-child) fieldset": {
    //   borderBottom: "none",
  },
}));

export const CFormHelperText = styled(FormHelperText)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 400,
  fontFamily: poppins.style.fontFamily,
  "&.MuiFormHelperText-root.Mui-error": {
    color: "#BA1A1A !important",
    fontFamily: poppins.style.fontFamily,
  },
}));

export const GetPhoneInputStyles = (phoneFieldError) => ({
  style: {
    padding: "18px 14px 18px 60px",
    width: "100%",
    color: "#0B132B",
    // background: "#F8F9FB",
    fontFamily: poppins.style.fontFamily,
    fontSize: "20px",
    fontWeight: 400,
    borderRadius: "8px",
    outline: "none",
    borderColor: phoneFieldError ? "#BA1A1A" : "#E8EAED",
  },
  onFocus: (e) => {
    e.target.style.border = "1px solid #006A4E";
    e.target.style.boxShadow = "0 0 0 .2px transparent";
  },
  onBlur: (e) => {
    e.target.style.borderColor = phoneFieldError ? "#BA1A1A" : "#E8EAED";
  },
});
